import type { AtomModel } from '@models/atom.model';

import type { MultiSelectTableEditorColumnData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<MultiSelectTableEditorColumnData>;
};

export const MultiSelectSettingsModal = ({ atom }: Props) => {
  atom;
  return <></>;
};
